import type {
  ContinuityProfileDto,
  ContinuityProfileInput,
  CreateShotRequest,
  GenerateShotRequest,
  JobDto,
  ProjectCosts,
  ReviewInput,
  ShotDto,
  ShotEstimate,
  UpdateShotRequest,
} from '@gc/shared';
import { apiRequest } from './client.js';

/** Fase 09: cliente de las rutas de vídeo avanzado. */
const base = (projectId: string) => `/projects/${projectId}`;

export const generarStoryboard = (projectId: string, expectedRevision: number) =>
  apiRequest<JobDto>(`${base(projectId)}/storyboard/generate`, { method: 'POST', body: { expectedRevision } });

export const listarPlanos = (projectId: string) => apiRequest<ShotDto[]>(`${base(projectId)}/shots`);

export const crearPlano = (projectId: string, input: CreateShotRequest) =>
  apiRequest<ShotDto[]>(`${base(projectId)}/shots`, { method: 'POST', body: input });

export const actualizarPlano = (projectId: string, shotId: string, input: UpdateShotRequest) =>
  apiRequest<ShotDto[]>(`${base(projectId)}/shots/${shotId}`, { method: 'PATCH', body: input });

export const eliminarPlano = (projectId: string, shotId: string, expectedRevision: number) =>
  apiRequest<ShotDto[]>(`${base(projectId)}/shots/${shotId}`, { method: 'DELETE', body: { expectedRevision } });

export const estimarPlano = (projectId: string, shotId: string, input: Pick<GenerateShotRequest, 'resolution'>) =>
  apiRequest<ShotEstimate>(`${base(projectId)}/shots/${shotId}/estimate`, { method: 'POST', body: input });

export const generarPlano = (projectId: string, shotId: string, input: GenerateShotRequest) =>
  apiRequest<{ job: JobDto; takeId: string; estimate: ShotEstimate }>(`${base(projectId)}/shots/${shotId}/generate`, { method: 'POST', body: input });

export const revisarTake = (projectId: string, shotId: string, takeId: string, input: ReviewInput) =>
  apiRequest<ShotDto>(`${base(projectId)}/shots/${shotId}/takes/${takeId}/review`, { method: 'POST', body: input });

export const elegirTake = (projectId: string, shotId: string, takeId: string, expectedRevision: number) =>
  apiRequest<ShotDto>(`${base(projectId)}/shots/${shotId}/active-take`, { method: 'PUT', body: { takeId, expectedRevision } });

export const obtenerPerfil = (projectId: string) => apiRequest<ContinuityProfileDto | null>(`${base(projectId)}/continuity-profile`);

export const guardarPerfil = (projectId: string, input: ContinuityProfileInput) =>
  apiRequest<ContinuityProfileDto>(`${base(projectId)}/continuity-profile`, { method: 'PUT', body: input });

export const obtenerCostes = (projectId: string) => apiRequest<ProjectCosts>(`${base(projectId)}/costs`);
